import { render, staticRenderFns } from "./SocialAuthBtn.vue?vue&type=template&id=6c8d8f0e&scoped=true&"
import script from "./SocialAuthBtn.vue?vue&type=script&lang=js&"
export * from "./SocialAuthBtn.vue?vue&type=script&lang=js&"
import style0 from "./SocialAuthBtn.vue?vue&type=style&index=0&id=6c8d8f0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c8d8f0e",
  null
  
)

export default component.exports